module.exports = require("styled-components");